import { botttsNeutral, micah } from '@dicebear/collection';
import { createAvatar } from '@dicebear/core';

export const getShippingAvatar = (seed) => {
  const safeSeed = seed || 'default-avatar';
  return createAvatar(micah, { seed: safeSeed, size: 70, clip: false });
};

export const getUserAvatar = (seed, size = 32, radius = 10) => {
  return createAvatar(botttsNeutral, { seed, size, radius, clip: false });
};
